/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';

@Injectable()
export class userDataService {
 public _timezone: any = null;
 public _timeZoneAbbr: any

  public getLocalTimeZone(dateInput: any) {
    if (this._timezone) return this._timezone;

    const dateObject = dateInput || new Date(),
      dateString = dateObject + ""

    this._timeZoneAbbr = (
      dateString.match(/\(([^\)]+)\)$/) ||
      dateString.match(/([A-Z]+) [\d]{4}$/)
    );

    if (this._timeZoneAbbr) {
      this._timeZoneAbbr = this._timeZoneAbbr[1].match(/[A-Z]/g).join("");
    }

    if (!this._timeZoneAbbr && /(GMT\W*\d{4})/.test(dateString)) {
      return RegExp.$1;
    }

    this._timezone = this._timeZoneAbbr;
    return this._timeZoneAbbr;
  }

  public getUserTimeZone(offset: any) {
    const timezonenames: any = { "UTC+0": "GMT", "UTC+1": "CET", "UTC+2": "EET", "UTC+3": "EEDT", "UTC+3.5": "IRST", "UTC+4": "MSD", "UTC+4.5": "AFT", "UTC+5": "PKT", "UTC+5.5": "IST", "UTC+6": "BST", "UTC+6.5": "MST", "UTC+7": "THA", "UTC+8": "AWST", "UTC+9": "AWDT", "UTC+9.5": "ACST", "UTC+10": "AEST", "UTC+10.5": "ACDT", "UTC+11": "AEDT", "UTC+11.5": "NFT", "UTC+12": "NZST", "UTC-1": "AZOST", "UTC-2": "GST", "UTC-3": "BRT", "UTC-3.5": "NST", "UTC-4": "CLT", "UTC-4.5": "VET", "UTC-5": "EST", "UTC-6": "CST", "UTC-7": "MST", "UTC-8": "PST", "UTC-9": "AKST", "UTC-9.5": "MIT", "UTC-10": "HST", "UTC-11": "SST", "UTC-12": "BIT" },
      offsetZone = (offset < 0) ? "UTC" + offset : "UTC+" + offset;
    return timezonenames[offsetZone];
  }

}
